module.exports = __webpack_public_path__ + "media/images/products/trial-desktop-df6aa59c38a34ded4f175301489b71fb.png";